var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInteriorShipHyperion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3600 1800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #505359;\n      }\n\n      .cls-2 {\n        fill: #151516;\n      }\n\n      .cls-3 {\n        fill: #e20a0a;\n      }\n\n      .cls-4 {\n        isolation: isolate;\n      }\n\n      .cls-5 {\n        fill: #242628;\n      }\n\n      .cls-6 {\n        opacity: .7;\n      }\n\n      .cls-6, .cls-7 {\n        fill: #fff;\n        mix-blend-mode: screen;\n      }\n\n      .cls-7 {\n        opacity: .8;\n      }\n\n      .cls-8 {\n        fill: #c2c6ce;\n      }\n\n      .cls-9 {\n        fill: #2a2b2d;\n      }\n\n      .cls-10 {\n        fill: #484a4f;\n      }\n\n      .cls-11 {\n        fill: #979a9e;\n      }\n\n      .cls-12 {\n        fill: #3d3f44;\n      }\n\n      .cls-13 {\n        fill: #282a2d;\n      }\n\n      .cls-14 {\n        fill: #333;\n      }\n\n      .cls-15 {\n        fill: #2f3135;\n      }\n\n      .cls-16 {\n        fill: #1f1f21;\n      }\n\n      .cls-17 {\n        fill: #383a3d;\n      }\n\n      .cls-18 {\n        fill: #343538;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Underlay"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 3600,
    height: 1800
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ship"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 3,
    y: 119,
    width: 3600,
    height: 1687,
    transform: "translate(3606 1925) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 3,
    width: 3600,
    height: 50
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 3,
    y: 85,
    width: 3600,
    height: 34
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "3122.5 112 3186.5 112 3226.5 8 3162.5 8 3122.5 112"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "2041.3 112 2105.3 112 2125.3 8 2061.3 8 2041.3 112"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "960.1 112 1024.1 112 994.1 8 930.1 8 960.1 112"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: -85.14,
    y: 119,
    width: 3715.27,
    height: 762.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: -86,
    y: 881,
    width: 3719,
    height: 499,
    transform: "translate(3547 2261) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: -80.53,
    y: 1380,
    width: 3689.06,
    height: 240
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 3,
    y: 1620,
    width: 3606,
    height: 37,
    transform: "translate(3612 3277) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1370.5 1807 2235.5 1807 2126.56 1380 1479.44 1380 1370.5 1807"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "2557 416 3356 416 3416 172 2607 172 2557 416"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "3203.88 283 3348.88 283 3353.88 263 3208.88 263 3203.88 283"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "2815.88 240 3360.88 240 3365.88 220 2820.88 220 2815.88 240"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "3113.88 326 3338.88 326 3343.88 306 3118.88 306 3113.88 326"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "2567 1515.87 3472 1515.87 3446.78 1483.55 2552 1483.55 2567 1515.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1064.24 1515.87 159.24 1515.87 184.47 1483.55 1079.24 1483.55 1064.24 1515.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1035.74 1571.97 130.74 1571.97 155.96 1539.65 1050.74 1539.65 1035.74 1571.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "2963 1110 3426 1110 3426 942 3023 942 2963 1110"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1091.17 1459.91 186.17 1459.91 211.39 1427.59 1106.17 1427.59 1091.17 1459.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1703.77 1707 1902.23 1707 1891.71 1653.64 1714.29 1653.64 1703.77 1707"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "1303.87 172 1386.72 739 1456.93 739 1372.76 172 1303.87 172"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1459.09 739 2134.58 739 2136.55 739 2232.51 172 1372.76 172 1456.93 739 1459.09 739"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "1386.72 739 1397.36 811.83 1457.25 741.17 1456.93 739 1386.72 739"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1457.25 741.17 1397.36 811.83 1397.68 814 1468.07 814 1457.25 741.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "1456.93 739 1457.25 741.17 1459.09 739 1456.93 739"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1457.25 741.17 1468.07 814 2123.86 814 2136.23 740.89 2134.58 739 1459.09 739 1457.25 741.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "2136.23 740.89 2123.86 814 2197.68 814 2197.99 812.09 2136.23 740.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "2134.58 739 2136.23 740.89 2136.55 739 2134.58 739"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "2136.55 739 2136.23 740.89 2197.99 812.09 2209.88 739 2136.55 739"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "2232.51 172 2136.55 739 2209.88 739 2302.12 172 2232.51 172"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "2961.88 369 3326.88 369 3331.88 349 2966.88 349 2961.88 369"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1491,
    y: 892,
    width: 624,
    height: 476
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2105,902v456h-604v-456h604M2125,882h-644v496h644v-496h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "2063.8 972.47 2063.8 1006.42 2034.4 1023.4 2005 1006.42 2005 972.47 2034.4 955.5 2063.8 972.47"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 2052.68,
    y: 1045,
    width: 11.32,
    height: 157,
    transform: "translate(4116.68 2247) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 2029.25,
    y: 1045,
    width: 11.32,
    height: 157,
    transform: "translate(4069.81 2247) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 2005,
    y: 1045,
    width: 11.32,
    height: 157,
    transform: "translate(4021.32 2247) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1539.8,
    y: 956,
    width: 24,
    height: 24,
    transform: "translate(3103.6 1936) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1539.8,
    y: 997.75,
    width: 24,
    height: 24,
    transform: "translate(3103.6 2019.5) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1539.8,
    y: 1039.5,
    width: 24,
    height: 24,
    transform: "translate(3103.6 2103) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1539.8,
    y: 1081.25,
    width: 24,
    height: 24,
    transform: "translate(3103.6 2186.5) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1582,
    y: 956,
    width: 76,
    height: 149,
    transform: "translate(3240 2061) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1571 1317 2034 1317 2064 1288 1541 1288 1571 1317"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1675.5,981.5h24v-26h58.82l24.18,24.18v125.82h-107v-124ZM1768.5,1093.21v-75.21l-69,75.21h69Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1847,
    y: 956,
    width: 131,
    height: 67,
    transform: "translate(3825 1979) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1847,
    y: 1045.33,
    width: 131,
    height: 67,
    transform: "translate(3825 2157.67) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1847,
    y: 1134.67,
    width: 131,
    height: 110.33,
    transform: "translate(3825 2379.67) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1783.37 1148.7 1783.37 1247.2 1756.1 1261.45 1728.82 1247.2 1728.82 1148.7 1756.1 1134.44 1783.37 1148.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1595.55 1148.7 1595.55 1247.2 1568.27 1261.45 1541 1247.2 1541 1148.7 1568.27 1134.44 1595.55 1148.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1662.19 1254.41 1699 1217.59 1662.19 1140.77 1625.37 1217.59 1662.19 1254.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2059.19 1264 1856.92 1264 1846.03 1245.14 1845.92 1226.27 2059.19 1226.27 2070.08 1245.14 2059.19 1264"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "3177 1309 3426 1309 3426 1141 3117 1141 3177 1309"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "2595.5 1571.97 3500.5 1571.97 3475.28 1539.65 2580.5 1539.65 2595.5 1571.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2963 942 2380 942 2380 1110 2903 1110 2963 942"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "1722.12 1608.92 1884.57 1608.92 1862.06 1445.56 1734.63 1445.56 1722.12 1608.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1699 1566 1902 1566 1907 1520 1694 1520 1699 1566"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "1698.53 1494 1901.53 1494 1906.53 1520 1693.53 1520 1698.53 1494"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1467.26,
    y: 365.85,
    width: 3.75,
    height: 3.75,
    transform: "translate(1476.88 -1146.71) rotate(76.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 2117.51,
    y: 561.79,
    width: 3.75,
    height: 3.75,
    transform: "translate(2162.79 -1628.96) rotate(76.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1737.18,
    y: 230.31,
    width: 3.75,
    height: 3.75,
    transform: "translate(1550.95 -1512.19) rotate(76.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1688.42,
    y: 430.87,
    width: 5.3,
    height: 5.3,
    transform: "translate(1709.94 -1312.13) rotate(76.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 2081.48,
    y: 671.98,
    width: 3.75,
    height: 3.75,
    transform: "translate(2242.36 -1509.99) rotate(76.24)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "839 814 1101 814 1001 172 739 172 839 814"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "507.25 816 769.25 816 669.25 174 407.25 174 507.25 816"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "176.25 814 438.25 814 338.25 172 76.25 172 176.25 814"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "839.71 809.91 1030.25 809.91 957.53 343 766.98 343 839.71 809.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "541.34 815.37 731.89 815.37 659.16 348.46 468.62 348.46 541.34 815.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "247.34 815.37 437.89 815.37 365.16 348.46 174.62 348.46 247.34 815.37"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 194,
    y: 920,
    width: 925,
    height: 422
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1114,925v412H199v-412h915M1124,915H189v432h935v-432h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 198.6,
    y: 1081.5,
    width: 916,
    height: 6,
    transform: "translate(1313.2 2169) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 198.6,
    y: 1156.75,
    width: 915,
    height: 6,
    transform: "translate(1312.2 2319.5) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 198.6,
    y: 1114.12,
    width: 915,
    height: 6,
    transform: "translate(1312.2 2234.25) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 198.6,
    y: 1272,
    width: 915,
    height: 6,
    transform: "translate(1312.2 2550) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 198.6,
    y: 1209.38,
    width: 915,
    height: 6,
    transform: "translate(1312.2 2424.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 532,
    y: 1209,
    width: 250,
    height: 6,
    transform: "translate(-555 1869) rotate(-90)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "757.14 1085.04 849.02 1338.07 855.53 1337.81 762.78 1082.99 757.14 1085.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "854.71 1085.92 1065.58 1337.21 1073 1337 859.31 1082.06 854.71 1085.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "970.17 1089.12 1114 1211 1114.13 1202.08 974.03 1084.53 970.17 1089.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "554.37 1083.5 461.96 1337.41 455 1337 548.74 1081.45 554.37 1083.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "456.74 1085.46 245.65 1337.02 239 1337 452.14 1081.6 456.74 1085.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "344.2 1086.43 199 1208 198.59 1200.77 340.34 1081.83 344.2 1086.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "705.2 1087.47 696.54 1082.47 712.11 1055.5 712.11 1025.71 697.21 999.9 671.4 985 641.6 985 615.79 999.9 600.89 1025.71 600.89 1055.5 616.46 1082.47 607.8 1087.47 590.89 1058.18 590.89 1023.03 608.47 992.58 638.92 975 674.08 975 704.53 992.58 722.11 1023.03 722.11 1058.18 705.2 1087.47"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "2540.66 1459.91 3445.66 1459.91 3420.44 1427.59 2525.66 1427.59 2540.66 1459.91"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteriorShipHyperion);
export default __webpack_public_path__ + "static/media/interior-ship-hyperion.0ea213d2cb71fdf7c4b279bea8c04794.svg";
export { ForwardRef as ReactComponent };